import HexagonImageReveal from './../components/HexagonGrid';

document.addEventListener('DOMContentLoaded', () => {
    const hexCanvas = document.getElementById('hexCanvas');
    if (hexCanvas) {
        console.log('HexCanvas found, initializing hexagon image reveal effect');

        // Path to your image - replace with your actual image URL
        const imageUrl = 'dist/images/bg/home2.jpg';

        const hexGrid = new HexagonImageReveal('hexCanvas', imageUrl, {
            hexSize: 60,
            horizontalSpacingFactor: 1.12,
            verticalSpacingFactor: 0.85,
            backgroundColor: '#212b3b',
            borderWidth: 1,
            borderMaxOpacity: 0.45,
            borderGradientRange: 6,
            borderBaseOpacity: 0.12,
            baseOpacity: 0,
            hoverOpacity: 0.5,
            nearOpacity: 0.3,
            farOpacity: 0.2,
            slowFadeSpeed: 0.03,
            activeTransitionSpeed: 0.5,
            proximityThresholds: [1, 2, 3],
            imageFit: 'cover',
            cullingMargin: 40,
            throttleTime: 24,
            optimizationLevel: 'high'
        });
    } else {
        console.log('HexCanvas not found on this page');
    }
});